import { render } from "./StatClientServis.vue?vue&type=template&id=f1bc0bba&scoped=true"
import script from "./StatClientServis.vue?vue&type=script&lang=js"
export * from "./StatClientServis.vue?vue&type=script&lang=js"

import "./StatClientServis.vue?vue&type=style&index=0&id=f1bc0bba&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1bc0bba"]])

export default __exports__